var _circle, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabelsAvilable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1433,
    cy: 24.9445,
    r: 15.3605,
    fill: "#A68367"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.4628,
    y: 1,
    width: 15.3605,
    height: 6.32491,
    rx: 3.16246,
    fill: "#A68367"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3328,
    y: 10.4873,
    width: 15.3605,
    height: 6.32491,
    rx: 3.16246,
    transform: "rotate(72.3781 45.3328 10.4873)",
    fill: "#A68367"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3715,
    y: 39.4014,
    width: 15.3605,
    height: 6.32491,
    rx: 3.16246,
    transform: "rotate(143.156 45.3715 39.4014)",
    fill: "#A68367"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 15.3605,
    height: 6.32491,
    rx: 3.16246,
    transform: "matrix(0.302703 -0.953085 -0.953085 -0.302703 6.0282 27.2031)",
    fill: "#A68367"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 15.3605,
    height: 6.32491,
    rx: 3.16246,
    transform: "matrix(-0.800313 -0.599582 -0.599582 0.800313 20.6382 43.4673)",
    fill: "#A68367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabelsAvilable);
export default __webpack_public_path__ + "static/media/tabelsAvilable.e9f4ea983bdc3fc9af43ec65c755011e.svg";
export { ForwardRef as ReactComponent };